module.exports = __webpack_public_path__ + "static/img/advertising03@tw.4aba2a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/advertising03@tw.jpg
// module id = Jp0e
// module chunks = 0